export * from "-!../../../node_modules/babel-loader/lib/index.js!../../../node_modules/vue-loader/lib/loaders/templateLoader.js??ref--2!../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./OrcidUnitAssignment.vue?vue&type=template&id=39c8cc7a&"


//////////////////
// WEBPACK FOOTER
// ./src/views/usage/OrcidUnitAssignment.vue?vue&type=template&id=39c8cc7a&
// module id = 1398
// module chunks = 0